export default {
  parameters: {
    landing_id: "TrQFC",
  },
  newDesign: true,
  title: "3 etkilesimli ders + bonus ders | Kodland",
  downtimeUrl: "https://cl.kodland.tech",
  startPage: {
    title:
      "4 soruyu yanıtlayın ve ücretsiz programlama kursu kazanın",
    subtitle:
      "✏️ 8-17 yaş arası çocuklar için<br>💻 Bir kodlama uzmanının yardımıyla ilk dijital projelerinizi oluşturun<br>🌐 İhtiyacınız olan tek şey bir bilgisayar ve internet bağlantısı<br>💙 100.000'den fazla ebeveyn tarafından seçildi",
    image: {
      url: "/welcome/coding_freecourse_turkey_desktop.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
    imageMobile: {
      url: "/welcome/coding_freecourse_turkey_mob.png",
      style: {
        width: "100%",
      },
    },
    button: " Hemen kayit olun 🚀 ",
  },
  stopPage: {
    image: "/welcome/quizV2/no-computer.png",
    title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
    subtitle:
      "Maalesef, tablet veya telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
  },
  quizRotateBySteps: {
    1: {
      question: "Çocugunuz genellikle bos zamanlarini nasil geçirir?",
      answers: [
        "🎮 Cep telefonu ve bilgisayarda oyun oynar",
        "🏀 Spor yapar",
        "🤝 Arkadaslariyla sosyallesir",
        "👀 Diğer"
      ],
    },
    2: {
      question: "Çocugunuzun okulda en sevdigi ders hangisidir?",
      answers: [
        "🔬 Fen bilimleri",
        "💻 Bilgisayar bilimi",
        "📐 Matematik",
        "👀 Diğer"
      ],
    },
    3: {
      typeInfo: "noQuestions",
      imageLink: "/welcome/reviews-tr.png",
      subtitle: "Dünyanın her yerinden ebeveynlerden referanslar alıyoruz. Umarız yakında siz de onlara katılırsınız 💙",
      button: "Gidelim!",
    },
    4: {
      question:
        "Çocuğunuzun çalışabileceği bir masaüstü veya dizüstü bilgisayarınız var mı?",
      answers: [
        "💻 Evet",
        {
          answer: "☹️ Hayir",
          stopAnswer: true,
        },
      ],
    },
    5: {
      title: "Çocuğunuz kaç yaşında?",
      subtitle: "Çocuğunuzun yaşına göre en eğlenceli kursu seçeceğiz.",
      type: "age",
      button: "",
    },
    6: {
      title: "Tebrikler! 🎉",
      typeInfo: "congrats",
      subtitle:
        "Kaydı tamamlamak için '📆 Rezervasyon yapın' seçeneğine tıklayın.",
      button: "📆 Rezervasyon yapın",
    },
    7: {
      title: "Ücretsiz ders rezervasyonu yapın",
      type: "one-page-contacts",
      subtitle: "",
      button: "Neredeyse bitti 🔥",
    },
    8: {
      title: "",
      type: "timeslot",
      subtitle: "",
      button: "",
    },
    9: {
      title:
        "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
      typeInfo: "pc-laptop",
      subtitle:
        "Derse katılmak için lütfen masaüstü veya dizüstü bilgisayar kullanın ve ders boyunca çocuğunuza eşlik etmeyi unutmayın. Deneme dersinin bireysel ve kişiye özel olduğunu hatırlatmak isteriz.",
      button: "Başka neler var?",
    },
    10: {
      title: "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
      typeInfo: "whatsapp",
      subtitle:
        "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
      button: "Başka neler var?",
    },
    11: {
      title: "Ders platformumuzda gerçekleşecek 💻",
      typeInfo: "classroom",
      subtitle:
        "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
      button: "Anladım ✅",
    }
  },
};
